import { Badge } from 'framework7-react';
import { ComponentProps, ReactNode } from 'react';

import Button, { ButtonProps } from '@components/buttons/Button';

import { PopoverContentComponent, PopoverWrapper } from '../Popover/PopoverWrapper';
import './EmptyState.scss';

type EmptyStateButton = Omit<ButtonProps, 'onClick'> &
  (
    | {
        text: string;
        badge?: number;
        onClick: () => void;
        PopoverContent?: undefined;
      }
    | {
        text: string;
        badge?: number;
        onClick?: undefined;
        PopoverContent: PopoverContentComponent;
      }
  );

export const EmptyState = ({
  className = '',
  title,
  text,
  content,
  button,
  secondaryButton,
}: {
  className?: string;
  title?: string;
  text?: string;
  content?: ReactNode;
  button?: EmptyStateButton;
  secondaryButton?: EmptyStateButton;
}) => {
  return (
    <div className={`empty-state-wrapper ${className}`}>
      <div className="empty-state">
        {title && <h4>{title}</h4>}
        {text && <p>{text}</p>}
        {content}
        {button?.onClick && (
          <div className="w-100" style={{ position: 'relative' }}>
            <Button {...button} onClick={button.onClick}>
              {button.text}
            </Button>
            {button.badge && (
              <Badge color="red" style={{ position: 'absolute', top: -8, right: -8 }}>
                {button.badge}
              </Badge>
            )}
          </div>
        )}
        {secondaryButton?.onClick && (
          <Button className="mt-2" variant="outlined" color="neutral" {...secondaryButton}>
            {secondaryButton.text}
          </Button>
        )}
        {button?.PopoverContent && (
          <PopoverWrapper className="w-100" PopoverContent={button?.PopoverContent}>
            <Button onClick={button.onClick}>{button.text}</Button>
          </PopoverWrapper>
        )}
      </div>
    </div>
  );
};
